import { render, staticRenderFns } from "./BrRow.vue?vue&type=template&id=fb6d25a4&scoped=true"
import script from "./BrRow.vue?vue&type=script&lang=js"
export * from "./BrRow.vue?vue&type=script&lang=js"
import style0 from "./BrRow.vue?vue&type=style&index=0&id=fb6d25a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6d25a4",
  null
  
)

export default component.exports